module.exports = __webpack_public_path__ + "img/12.bbc7d34f.jpg";